<template>
  <div :class="['flex flex-col', compactMode ? 'gap-4' : 'gap-6']">
    <div :class="['flex flex-col px-4 pt-4 w-full', compactMode ? 'pb-0' : 'pb-4']">
      <div :class="['flex flex-col gap-8', breakpointClasses[breakpoint]]">
        <div class="flex flex-col gap-4">
          <p
            v-if="shiftSelectionTitle"
            class="text-body-1 text-secondary-text"
            data-testid="shift-selection-title"
          >
            {{ shiftSelectionTitle }}
          </p>

          <ShiftSelector :shift="selectedShift" @shift-update="updateShift" />
        </div>

        <div
          v-if="selectedShift && selectedShift !== ShiftTypeDTO.NO_SHIFT"
          :class="['flex flex-col gap-4', compactMode ? 'px-4 pb-4 md:min-w-[376px]' : 'flex-1']"
          data-testid="shift-end-selector-section"
        >
          <p class="text-body-1 text-secondary-text">{{ t('Select shift end') }}.</p>

          <ShiftEndSelector
            :class="compactMode ? 'flex-col md:flex-row' : 'flex-col'"
            :selected-date="selectedDate"
            :selected-time="selectedTime"
            :time-options="timeOptions"
            :is-error="isTwoOrMoreDaysAfter || isDateTimeInThePast"
            @update:selected-date="onDateSelection"
            @update:selected-time="updateSelectedTime"
          />
        </div>
      </div>
    </div>

    <div :class="['flex gap-4 w-full', compactMode ? 'px-4 pb-4' : 'justify-end']">
      <slot name="additional-actions" />

      <VBtn
        data-testid="submit-button"
        :class="[
          'font-semibold px-5 text-[15px] leading-[26px] flex h-auto',
          compactMode ? 'py-1' : 'py-2'
        ]"
        :text="submitButtonText"
        :color="'primary'"
        @click="() => onSubmit(true)"
      />
    </div>

    <p v-if="errorMessage" class="text-sm text-error-600" data-testid="error-message">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { ShiftTypeDTO } from '@/generated'
import ShiftEndSelector from '@/components/shift/ShiftEndSelector.vue'
import ShiftSelector from '@/components/shift/ShiftSelector.vue'
import useShiftForm from '@/composables/shift/useShiftForm'
import { useI18n } from 'vue-i18n'

type Breakpoint = 'sm' | 'xl'

interface Props {
  compactMode: boolean
  submitButtonText: string
  shiftSelectionTitle?: string
  breakpoint: Breakpoint
}

defineProps<Props>()

const breakpointClasses = {
  sm: 'sm:flex-row sm:gap-16',
  md: 'md:flex-row md:gap-16',
  lg: 'lg:flex-row lg:gap-16',
  xl: 'xl:flex-row xl:gap-16'
}

const {
  selectedShift,
  selectedTime,
  selectedDate,
  errorMessage,
  timeOptions,
  isTwoOrMoreDaysAfter,
  isDateTimeInThePast,
  updateShift,
  updateSelectedTime,
  onDateSelection,
  onSubmit
} = useShiftForm()

const { t } = useI18n()
</script>

<style scoped></style>
